import React from 'react';
import { Input, Popconfirm } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import AppModal from '@/pages/inside/tenant/AppModal';
import { CreateRoleModalBody, DetailPersonChipAvatar } from '@/pages/inside/tenant/style';
import { ENV } from '@configs/env';
import { getAvatarColor, getInitials } from '@hooks/projects/projectHelpers';
import { resolveProfileImageUrl, getMemberRoleLabel } from '@hooks/projects/detail/useProjectDetail';

export default function ProjectMembersModal({
    open,
    onCancel,
    search,
    onSearchChange,
    visibleAssignedUsers,
    canManageMembers,
    projectCreatorId,
    onRemoveMember,
    removePending,
}) {
    return (
        <AppModal
            title="Project Members"
            open={open}
            onCancel={onCancel}
            footer={null}
            size="md"
        >
            <CreateRoleModalBody>
                <Input
                    allowClear
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder="Search members by name or email"
                    style={{ marginBottom: 12 }}
                />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: 360, overflow: 'auto' }}>
                    {visibleAssignedUsers.length ? (
                        visibleAssignedUsers.map((u) => (
                            <div
                                key={u.id ?? u.email}
                                style={{
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    padding: '8px 10px',
                                    borderRadius: 10,
                                    border: '1px solid var(--ant-color-border-secondary)',
                                }}
                            >
                                <DetailPersonChipAvatar $bg={u.profileImage ? 'transparent' : getAvatarColor(u.id)} style={{ width: 44, height: 44, fontSize: 14 }}>
                                    {u.profileImage ? (
                                        <img
                                            src={resolveProfileImageUrl(u.profileImage, ENV.API_URL)}
                                            alt={u.name || u.email || 'Member avatar'}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%', border: '1px solid var(--ant-color-border-secondary, #d9d9d9)' }}
                                        />
                                    ) : (
                                        getInitials(u.name || u.email)
                                    )}
                                </DetailPersonChipAvatar>
                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.35 }}>
                                        {u.name || 'Unnamed member'}
                                    </div>
                                    <div style={{ fontSize: 12, opacity: 0.8, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {getMemberRoleLabel(u)}
                                    </div>
                                </div>
                                {canManageMembers && String(u.id) !== String(projectCreatorId) && (
                                    <Popconfirm
                                        title="Remove Member"
                                        description="Are you sure you want to remove this member from the project?"
                                        onConfirm={() => onRemoveMember(u.id)}
                                        okText="Yes"
                                        cancelText="No"
                                        okButtonProps={{ danger: true, loading: removePending }}
                                    >
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: -6,
                                                right: -6,
                                                width: 18,
                                                height: 18,
                                                borderRadius: '50%',
                                                backgroundColor: '#ff4d4f',
                                                color: '#fff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                fontSize: 9,
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                                transition: 'all 0.2s ease',
                                            }}
                                            className="member-remove-dot"
                                            title="Remove from project"
                                        >
                                            <CloseOutlined />
                                        </div>
                                    </Popconfirm>
                                )}
                            </div>
                        ))
                    ) : (
                        <span style={{ fontSize: 13, color: 'var(--ant-color-text-tertiary)' }}>No members found.</span>
                    )}
                </div>
            </CreateRoleModalBody>
        </AppModal>
    );
}
